import React from 'react'
import { RegisterOptions } from 'react-hook-form'
import { ClassName } from 'types/props'

import { FIELDS } from '../constants'
import { PasswordField, PasswordFieldProps } from '../password-field'

interface Props extends Partial<PasswordFieldProps> {
  validators?: RegisterOptions
}
export interface PasswordField extends ClassName {
  password?: string
}
export const Password = ({ validators, ...props }: Props) => (
  <PasswordField
    id={FIELDS.password.id}
    label={FIELDS.password.label}
    validators={validators}
    {...props}
  />
)

export interface ConfirmPasswordField extends ClassName {
  confirmPassword?: string
}
export const ConfirmPassword = ({ validators, ...props }: Props) => (
  <PasswordField
    id={FIELDS.confirmPassword.id}
    label={FIELDS.confirmPassword.label}
    validators={validators}
    {...props}
  />
)

export interface OldPasswordField {
  oldPassword?: string
}
export const OldPassword = ({ validators, ...props }: Props) => (
  <PasswordField
    id={FIELDS.oldPassword.id}
    label={FIELDS.oldPassword.label}
    validators={validators}
    {...props}
  />
)

export interface NewPasswordField {
  newPassword?: string
}
export const NewPassword = ({ validators, ...props }: Props) => (
  <PasswordField
    id={FIELDS.newPassword.id}
    label={FIELDS.newPassword.label}
    validators={validators}
    {...props}
  />
)
